// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
:host {
  display: block;
  overflow: hidden;
  position: relative;
}

.inner {
  height: 500px;
  position: absolute;
  top: 0;
  will-change: left;
}
.inner img {
  transform: translateX(-50%);
  transform: translateX(-50%);
  transform: translateX(-50%);
  transform: translateX(-50%);
  transform: translateX(-50%);
  height: 500px !important;
  left: 50%;
  max-width: 1400px;
}

.outer-box {
  height: 500px;
  margin-bottom: 30px;
  position: relative;
}

app-dot-indicator {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  display: flex;
  flex-direction: row;
  height: 17px;
  justify-content: left;
  padding-left: 100px;
  overflow: visible;
  position: absolute;
  width: 100%;
  transform: translate(0%, -185%);
}

@media (max-width: 500px) {
  app-dot-indicator {
    padding-left: 30px !important;
  }
}
@media (max-width: 400px) {
  app-dot-indicator {
    transform: translate(0%, 0%);
  }
}
.buttons {
  position: absolute;
  width: 100%;
  z-index: 100;
}

app-nav-button {
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.circle {
  border-radius: 50%;
  border-radius: 50%;
  border-radius: 50%;
  border-radius: 50%;
  border-radius: 50%;
  opacity: 85%;
  font-family: arial;
  font-size: 30px;
  outline: none;
}
.circle:focus {
  outline-offset: -1px;
}

a {
  display: block;
  line-height: 36px;
  text-align: center;
}
a.disabled {
  visibility: hidden;
}

.dot {
  border-radius: 50%;
  border-radius: 50%;
  border-radius: 50%;
  border-radius: 50%;
  border-radius: 50%;
  transition: opacity 90ms linear;
  transition: opacity 90ms linear;
  transition: opacity 90ms linear;
  transition: opacity 90ms linear;
  transition: opacity 90ms linear;
  background: #959595 !important;
  cursor: pointer;
  height: 10px;
  margin: 0 5px;
  width: 10px;
  line-height: 21px;
  color: transparent;
  font-size: 12px;
}
.dot.active {
  background: hsl(204.9, 94.4%, 35.1%) !important;
  height: 10px;
  opacity: 1;
  line-height: 24px;
  width: 10px;
}

@media (max-width: 1024px) {
  .outer-box {
    margin-bottom: 0;
  }
}
@-moz-document url-prefix() {
  @media (max-width: 1024px) {
    .outer-box {
      margin-bottom: 0;
      margin-top: -35px !important;
    }
  }
}
.dot-new-picker {
  margin-left: auto;
  margin-right: auto;
  max-width: 1250px;
}

@media (max-width: 1024px) and (min-width: 501px) {
  .dot-new-picker {
    left: 10% !important;
    width: 60% !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
}
@media (max-width: 500px) {
  .dot-new-picker {
    left: 0% !important;
  }
}
/** Mozilla Firefox */
@-moz-document url-prefix() {
  @media (max-width: 1024px) {
    .inner {
      margin-top: 35px;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/lib/ng2-sapmp/src/ui-components/page-slider/pageslider.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAmJF;;AAhJA;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,iBAAA;AAmJF;AAjJE;EFsBE,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EEpBA,wBAAA;EACA,SAAA;EACA,iBAAA;AAuJJ;;AAnJA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAsJF;;AAnJA;EAIE,wBAAA;EACA,qBAAA;EAGD,aAAA;EACA,mBAAA;EACC,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,+BAAA;AAsJF;;AAjJA;EACE;IACE,6BAAA;EAoJF;AACF;AAjJA;EACE;IACE,4BAAA;EAmJF;AACF;AAhJA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAkJF;;AA9IA;EACC,eAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;AAiJD;;AA9IA;EF1CI,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EE+CF,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AAkJF;AA9IE;EACE,oBAAA;AAgJJ;;AA5IA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AA+IF;AA7IE;EACE,kBAAA;AA+IJ;;AA3IA;EFrEI,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EEwEF,8BAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EAEC,kBAAA;EACD,eAAA;AAqJF;AAlJE;EACE,+CAAA;EACA,YAAA;EAEA,UAAA;EACA,iBAAA;EACA,WAAA;AAmJJ;;AFxPI;EE0GF;IACE,gBAAA;EAkJF;AACF;AA/IA;EF/GI;IEiHA;MACE,gBAAA;MACA,4BAAA;IAiJF;EACF;AACF;AA9IA;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;AAgJF;;AA7IA;EACE;IACE,oBAAA;IACA,qBAAA;IACA,2BAAA;IACA,4BAAA;EAgJF;AACF;AA7IA;EACE;IACE,mBAAA;EA+IF;AACF;AA5IA,qBAAA;AAEA;EF/II;IEiJF;MACE,gBAAA;IA6IA;EACF;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../assets/style/mixinfunction';\n\n:host {\n  display: block;\n  overflow: hidden;\n  position: relative;\n}\n\n.inner {\n  height: 500px;\n  position: absolute;\n  top: 0;\n  will-change: left;\n\n  img {\n    @include vendor-prefix('transform', translateX(-50%));\n    height: 500px !important;\n    left: 50%;\n    max-width: 1400px;\n  }\n}\n\n.outer-box {\n  height: 500px;\n  margin-bottom: 30px;\n  position: relative;\n}\n\napp-dot-indicator {\n  -webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: row;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  display: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tflex-direction: row;\n  height: 17px;\n  justify-content: left;\n  padding-left: 100px;\n  overflow: visible;\n  position: absolute;\n  width: 100%;\n  transform: translate(0%, -185%);\n}\n\n\n\n@media (max-width: 500px) {\n  app-dot-indicator {\n    padding-left: 30px !important;\n  }\n}\n\n@media (max-width: 400px) {\n  app-dot-indicator {\n    transform: translate(0%,0%);\n  }\n}\n\n.buttons {\n  position: absolute;\n  width: 100%;\n  z-index: 100;\n}\n\n\napp-nav-button {\n\tcursor: pointer;\n\t-webkit-touch-callout: none; /* iOS Safari */\n\t-webkit-user-select: none;   /* Chrome/Safari/Opera */\n\t-khtml-user-select: none;    /* Konqueror */\n\t-moz-user-select: none;      /* Firefox */\n\t-ms-user-select: none;       /* Internet Explorer/Edge */\n\tuser-select: none;\n}\n\n.circle {\n  @include vendor-prefix('border-radius', 50%);\n  // background-color: #ffffff !important;\n  // border: 1px solid #000000;\n  // color: #000000;\n  opacity: 85%;\n  font-family: arial;\n  font-size: 30px;\n  outline: none;\n  // height: 61px;\n  // width: 61px;\n\n  &:focus {\n    outline-offset: -1px;\n  }\n}\n\na {\n  display: block;\n  line-height: 36px;\n  text-align: center;\n\n  &.disabled {\n    visibility: hidden;\n  }\n}\n\n.dot {\n  @include vendor-prefix('border-radius', 50%);\n  @include vendor-prefix('transition', opacity 90ms linear);\n  background: color(inverse, lighter) !important;\n  cursor: pointer;\n  height: 10px;\n  margin: 0 5px;\n  width: 10px;\n  line-height: 21px;\n  //color: color(inverse, darkest);\n   color: transparent;\n  font-size: 12px;\n\n\n  &.active {\n    background: color(secondary, base) !important;\n    height: 10px;\n    // margin-top: -2px ;\n    opacity: 1;\n    line-height: 24px;\n    width: 10px;\n  }\n}\n\n@include respond-to(small) {\n  .outer-box {\n    margin-bottom: 0;\n  }\n}\n\n@-moz-document url-prefix() {\n  @include respond-to(small) {\n    .outer-box {\n      margin-bottom: 0;\n      margin-top: -35px !important;\n    }\n  }\n}\n\n.dot-new-picker {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1250px;\n}\n\n@media (max-width: 1024px) and (min-width: 501px) {\n  .dot-new-picker {\n    left: 10% !important;\n    width: 60% !important;\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n  }\n}\n\n@media (max-width: 500px) {\n  .dot-new-picker {\n    left: 0% !important;\n  }\n}\n\n/** Mozilla Firefox */\n\n@-moz-document url-prefix() {\n  @include respond-to(small) {\n  .inner {\n    margin-top: 35px;\n    } \n    // .outer-box{\n    //   margin-top: 35px;\n    // }\n  }\n  }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
